import { Button, Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";

import { removeMessageImage, uploadMessageImage } from "../redux/chatSlice";
import { SendIcon } from "../../../constants/icon_path";

const UploadImageButton = ({ handleClose, sendMessage }) => {
  const dispatch = useDispatch();
  const chat = useSelector((state) => state.chat);
  const { uploadLoading, file, currentChat } = chat;

  const handleSend = async () => {
    const { payload } = await dispatch(uploadMessageImage({ handleClose }));
    if (payload) {
      dispatch(removeMessageImage());
      await sendMessage({
        variables: {
          input: {
            member: currentChat?.memberId,
            message: "",
            isAdmin: true,
            isImage: true,
            imageUrl: payload.url,
          },
        },
      });
    }
  };

  return (
    <Button
      type="button"
      onClick={handleSend}
      style={{ marginLeft: "5px" }}
      disabled={!file}
    >
      {uploadLoading ? (
        <Spinner variant="light" animation="border" size="sm" />
      ) : (
        <SendIcon size={20} />
      )}
    </Button>
  );
};

export default UploadImageButton;
